import React, { useRef, useState } from "react";
import IncomingDateInput from "./IncomingDateInput";
import { buddhistBirthDateToIso, formatBuddhistBirthDate, isValidIncomingBirthDate } from "./incomingPatientDates";

export default function IncomingBirthDateInput({ defaultValue, name, onChange, ...props }) {
  const [era, setEra] = useState("BE");
  const [iso, setIso] = useState(defaultValue || "");
  const [draft, setDraft] = useState(() => formatBuddhistBirthDate(defaultValue));
  const [invalid, setInvalid] = useState(false);
  const fieldRef = useRef(null);
  const invalidMessage = era === "BE" ? "กรอกวันเดือนปีเกิด พ.ศ. ที่ถูกต้อง เช่น 02/01/2523" : "กรอกวันเดือนปีเกิด ค.ศ. ที่ถูกต้อง เช่น 02/01/1980";
  const saveDate = (value) => {
    setIso(value);
    onChange({ target: { name, value } });
  };
  return (
    <div ref={fieldRef}>
      <div className="d-flex align-items-start" style={{ gap: 8 }}>
        <select
          className="form-control"
          style={{ width: 90, flexShrink: 0 }}
          aria-label="DOB year era"
          value={era}
          onChange={(event) => {
            setEra(event.target.value);
            setDraft(formatBuddhistBirthDate(iso));
            setInvalid(false);
          }}
        >
          <option value="BE">พ.ศ.</option>
          <option value="CE">ค.ศ.</option>
        </select>
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          {era === "CE" ? (
            <IncomingDateInput {...props} name={name} defaultValue={iso}
              minDate={new Date(1900, 0, 1)} maxDate={new Date()} aria-invalid={invalid}
              onChangeRaw={(event) => {
                if (!event || !event.target || typeof event.target.value !== "string") return;
                const value = event.target.value.trim();
                const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
                const isInvalid = Boolean(value) && (!match || !isValidIncomingBirthDate(`${match[3]}-${match[2]}-${match[1]}`));
                setInvalid(isInvalid);
                event.target.setCustomValidity(isInvalid ? invalidMessage : "");
              }}
              onChange={(event) => {
                setInvalid(false);
                fieldRef.current.querySelector("input").setCustomValidity("");
                saveDate(event.target.value);
              }} />
          ) : (
            <input
              {...props}
              type="text"
              name={name}
              value={draft}
              placeholder="dd/mm/yyyy"
              aria-invalid={invalid}
              onChange={(event) => {
                const value = event.target.value;
                setDraft(value);
                const converted = value.trim() ? buddhistBirthDateToIso(value) : "";
                const isInvalid = converted === null;
                setInvalid(isInvalid);
                event.target.setCustomValidity(isInvalid ? invalidMessage : "");
                if (!isInvalid) saveDate(converted);
              }}
            />
          )}
        </div>
      </div>
      {invalid ? <small className="text-danger">{invalidMessage}</small> :
        <small className="text-muted">กรอก dd/mm/yyyy · {era === "BE" ? "ปี พ.ศ." : "ปี ค.ศ."}</small>}
    </div>
  );
}
